export default __webpack_public_path__ + "static/media/obj.31f7e3e7.svg";